export const environment = {
    production: true,
    serverUrl: 'https://back.lachoco.ioonic.es',
};
